<template>
    <TolgeeProvider :tolgee="tolgee">
        <f7-app v-bind="vc.config">
            <Transition name="fade" mode="out-in">
                <SocketToastState v-if="vc.showSocketToast.value" />
            </Transition>
            <Transition name="fade" mode="out-in">
                <MainViews v-if="(isReady && isAuth) || loading" />
                <f7-view main url="/auth-error" v-else :preload-previous-page="false" :ios-swipe-back="false"></f7-view>
            </Transition>

            <payment-feedback-cancel v-if="vc.paymentService.feedbackCancelService.modalIsVisible.value"/>
            <payment-amount-changed-modal v-if="vc.paymentService.amountModal.value.isModalVisible"/>
            <payment-selected-agent-changed v-if="vc.paymentService.selectedAgentChangedModal.value.isModalVisible" />
            <payment-international-country-modal v-if="vc.paymentService.transgranModal.value.isModalVisible"/>
        </f7-app>
    </TolgeeProvider>
</template>

<script lang="ts" setup>
// @ts-ignore
import {f7, f7ready} from 'framework7-vue';
import AppController from "./ts/AppController";
import MainViews from "../views/MainViews.vue";
import {onBeforeMount, ref} from "vue";
import ServiceReleazio from "@/services/v2/service-releazio/ServiceReleazio";
import LangService from "@/services/LangService";
import PaymentFeedbackCancel from "@components/modals/payment-feedback-cancel/PaymentFeedbackCancel.vue";
import PaymentAmountChangedModal from "@components/modals/payment-amount-changed/PaymentAmountChangedModal.vue";
import PaymentInternationalCountryModal
	from "@components/modals/payment-international-country/PaymentInternationalCountryModal.vue";
import SocketToastState from "@components/ui/sockets/SocketToastState.vue";
import PaymentSelectedAgentChanged
	from "@components/modals/payment-selected-agent-changed/PaymentSelectedAgentChanged.vue";
import {TolgeeProvider} from "@tolgee/vue";
import {tolgee} from "@/langs/tolgee";

const vc = AppController.of();
const isReady = vc.isReady;
const isAuth = vc.isAuth;
const loading = ref(false);

onBeforeMount(async () => {
    try {
        loading.value = true;
        await vc.beforeInitStep().init();
        await runCheckReleazioVersion();
    } catch (e) {
    } finally {
        loading.value = false;
    }
});

async function runCheckReleazioVersion() {
    const serviceRealizio = AppController.of().service<ServiceReleazio>("releazio");
    if (serviceRealizio) {
        await serviceRealizio.fetchVersionConfig(LangService.getInstance().get());
        serviceRealizio.updateViewPost();
        serviceRealizio.checkCurrentVersionOld();

        if (serviceRealizio.isNeedUpdate.value) {
            serviceRealizio.openNeedUpdatePopup();
        }
    }
}
</script>

<style lang="scss">
.no-data-page {
    .page-content {
        .info-block {
            margin-top: 56px;
        }
    }
}
</style>
